import { ReactNode } from 'react'
// children type
export type ChildrenProps = {
  children: ReactNode
}

// Button type
export type ButtonTypes = 'default' | 'danger' | 'success' | 'info'
// UserRole
export enum UserRole {
  ADMIN = 'admin',
  AdMINISTRATOR = 'OAuthAdminAdministrator',
  AdminWatcher = 'Admin_Watcher',
  Accountant = 'Accountant',
  PILGRIM = 'pilgrim',
  BROKER = 'borker',
  PROVICEBROKER = 'provincebroker',
}

export type TableColumns = {
  Header: string
  accessor: string
}

export type TableData = Record<
  string,
  string | number | boolean | undefined | null | Date | ReactNode
>

export enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  TopCenter = 'top-center',
}

export type TExcelRportColumnData = {
  lable: string
  value: string
  isBoolean?: boolean
  isGregorianDate?: boolean
  isPrice?: boolean
  isPersianDate?: boolean
}[]

export type TSelectOptions = {
  value: string
  label: string
}

export enum PaymentStatus {
  'UNPAYMENTED' = 0,
  'TemporaryPayment' = 1,
  'CANCELED' = 2,
  'DELETED' = 3,
  'PAYMENTED' = 4,
}
export enum PaymentStatusText {
  'UNPAYMENTED' = 'پرداخت نشده',
  'TemporaryPayment' = 'پرداخت علی الحساب',
  'CANCELED' = 'انصراف',
  'DELETED' = 'حذف شده',
  'PAYMENTED' = 'پرداخت قطعی',
}

export enum BankPaymentStatusText {
  'TemporaryPayment' = 'پرداخت علی الحساب',
  'PAYMENTED' = 'پرداخت شده',
  'UNPAYMENTED' = 'پرداخت نشده',
}

export type TOptions = {
  value: string
  label: string
}

export enum TransportationType {
  'Road' = 1,
  'Flight' = 2,
}
export enum AgeGroup {
  'UnderTwoYears' = 'زیر دو سال',
  'BetweenTwoUntilSeven' = 'بین 2 تا 7',
  'BetweenSevenUntilTwelve ' = 'بین 7 تا 12',
  'Adult' = 'بزرگسال',
}
